import React, { useEffect } from 'react'
import { Toast } from '@paypalcorp/pp-react'
import PropTypes from 'prop-types'
import { noop } from 'lodash-es'
import { css } from '@emotion/react'

const blackBackgroundToastStyles = css`
  background-color: #000 !important;
  .ppvx_toast__content {
    color: #fff !important;
    background-color: #000 !important;
  }
  .ppvx_toast__message {
    color: #fff !important;
  }
  .ppvx_toast__container {
    background-color: #000 !important;
  }
`

const ToastWithCallbackBlackText = ({ onShown = noop, isSuccess, ...props }) => {
  useEffect(() => onShown(), [onShown])
  return <Toast {...props} isSuccess={isSuccess} duration={7000} css={blackBackgroundToastStyles} />
}

ToastWithCallbackBlackText.propTypes = {
  onShown: PropTypes.func,
  isSuccess: PropTypes.bool,
}

export default ToastWithCallbackBlackText